export type NotificationSeverity = 'info' | 'success' | 'warning' | 'critical'
export type NotificationTab = 'actionable' | 'all' | 'archived'
export type NotificationChannel = 'inapp' | 'toast' | 'email' | 'telegram'
export type NotificationScopeType = 'category' | 'event'

export interface NotificationItem {
  id: string | number
  event_id?: string | number
  entity_id?: string | number
  job_id?: string | number
  event_key: string
  category: string
  severity: NotificationSeverity
  title: string
  body?: string | null
  action_url?: string | null
  action_label?: string | null
  is_actionable: boolean | number
  group_key?: string | null
  seen_at?: string | null
  read_at?: string | null
  archived_at?: string | null
  created_at: string
  actor_name?: string | null
  actor?: { name?: string; user_name?: string } | null
  event?: {
    actor_name?: string | null
    actor?: { name?: string; user_name?: string } | null
  } | null
  context?: NotificationFrameContext
}

export interface NotificationBadge {
  unseen: number
  unread: number
  actionable: number
}

export interface NotificationListResponse {
  notifications: NotificationItem[]
  total: number
  page: number
  limit: number
  hasMore: boolean
}

export interface NotificationFilters {
  tab?: NotificationTab
  category?: string
  unreadOnly?: boolean
  page?: number
  limit?: number
}

export interface NotificationPreference {
  user_id?: number
  scope_type: NotificationScopeType
  scope_key: string
  channel: NotificationChannel
  enabled: boolean | number
}

export interface NotificationPreferenceUpdate {
  scopeType: NotificationScopeType
  scopeKey: string
  channel: NotificationChannel
  enabled?: boolean
  reset?: boolean
}

export type CatalogChannelDefault = boolean | 'never' | 'if_online' | 'if_unread' | 'immediate'

export interface NotificationCatalogEvent {
  key: string
  category?: string
  label?: string
  title?: string
  description?: string
  severity: NotificationSeverity
  actionable?: boolean
  channels?: Partial<Record<NotificationChannel, CatalogChannelDefault>>
  default_enabled?: Partial<Record<NotificationChannel, boolean>>
  defaultEnabledFor?: string[]
  canDisableInApp?: boolean
  required?: boolean
}

export interface NotificationCatalogCategoryDescriptor {
  key: string
  label: string
}

export interface NotificationCatalogCategory {
  key: string
  label: string
  events: NotificationCatalogEvent[]
}

export interface NotificationCatalog {
  categories: Array<NotificationCatalogCategory | NotificationCatalogCategoryDescriptor>
  events?: NotificationCatalogEvent[]
}

export interface NotificationFrameContext {
  payload?: { jobId?: string | number; [key: string]: unknown }
  entity?: { id?: string | number; [key: string]: unknown } | null
}

export interface NotificationsWebSocketFrame {
  type: 'notification.created' | 'notification.badge' | string
  data?: NotificationItem | NotificationBadge
  toast?: boolean
  context?: NotificationFrameContext
}

export const isActionableNotification = (item: NotificationItem): boolean =>
  item.is_actionable === true || item.is_actionable === 1
